// useFileUpload.ts
import React from 'react';
import { uploadFileToBlob } from '../utils/uploadFileToBlobStorage';
import { IOrchestratorTriggerEtlBody } from '../../../../../../../interface/interfaces';
import toast from 'react-hot-toast';
import { useAppDispatch, useAppSelector } from '../../../../../../../redux/hooks';
import { fetchOrchestrationTriggerEtlPending } from '../../Orchestrator/orchestratorTriggerEtl.slice';
import { rootState } from '../../../../../../../redux/store';
import { substringWords } from '../../../../../../../utils/substringWords';
import { addFile, updateFileStatus, setLastUploadedFile } from '../fileList.slice';

export const useFileUpload = () => {
    const dispatch = useAppDispatch();
    const { files, lastUploadedFile } = useAppSelector((state: rootState) => state.fileList);
    const { project } = useAppSelector((state: rootState) => state.project);
    const MAX_FILES = 5;

    // useEffect(() => {
    //     console.log('Files updated:', files);
    // }, [files]);

    const uploadFiles = async (filesToUpload: FileList | null) => {

        if (!filesToUpload) return;

        const fileArray = Array.from(filesToUpload);

        if (files.length + fileArray.length > MAX_FILES) {
            toast.error(`You can upload up to ${MAX_FILES} files.`);
            return;
        }

        // Dodaj samo nove fajlove u listu
        const newFiles = fileArray.filter((file) => !files.some((f) => f.name === file.name));

        const alreadyUploadedFiles = fileArray.filter((file) => files.some((f) => f.name === file.name));

        if (alreadyUploadedFiles.length > 0) {
            alreadyUploadedFiles.forEach((file) => {
                toast.error(`${substringWords(file.name, 30)} has already been uploaded.`);
            });
        }

        // Dodaj nove fajlove u Redux stanje
        newFiles.forEach((file) => {
            dispatch(addFile({ name: file.name, status: 'Uploading...' }));
        });

        // Upload novih fajlova
        for (const file of newFiles) {
            try {
                await uploadFileToBlob(file);

                // Ažuriraj status fajla u Redux-u
                dispatch(updateFileStatus({ fileName: file.name, status: 'Uploaded' }));

                const uploadedFileInfo = { name: file.name, status: 'Uploaded' };
                dispatch(setLastUploadedFile(uploadedFileInfo));

                // Pokreni ETL
                dispatch(updateFileStatus({ fileName: file.name, status: 'triggering' }));

                const body: IOrchestratorTriggerEtlBody = {
                    files: [
                        {
                            file_url: `${process.env.REACT_APP_BLOB_STORAGE_URL}/${process.env.REACT_APP_BLOB_STORAGE_CONTAINER}/${file.name}`,
                        },
                    ],
                    project_name: project?.name || 'Default project name',
                };

                // Triggerovanje ETL-a
                dispatch(
                    fetchOrchestrationTriggerEtlPending({
                        url: `${process.env.REACT_APP_ORCHESTRATOR_ROOT}/trigger-etl/`,
                        token: '',
                        body,
                    }),
                );

                // Postavljanje statusa "triggered" nakon što se ETL završi
                dispatch(updateFileStatus({ fileName: file.name, status: 'triggered' }));
                toast.success(substringWords(`Knowledge graph generated for file: "${file.name}".`, 50));
            } catch (error) {
                // Ako upload ne uspe, postavi status "Failed" u Redux-u
                dispatch(updateFileStatus({ fileName: file.name, status: 'Failed' }));
                console.error(`Failed to upload: ${file.name}`, error);
            }
        }
    };

    return {
        files,
        uploadFiles,
        lastUploadedFile,
    };
};
